import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs';

import { RequisitionsConfigActions } from '../config/config.store';
import { RequisitionsFlowsActions } from '../flows/flows.store';
import { RequisitionsFormActions } from '../form/form.store';

@Injectable({
  providedIn: 'root',
})
export class RequisitionsCommonEffects {
  private readonly actions$ = inject(Actions);

  public refresh$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RequisitionsConfigActions.updateWithDepartmentsSuccess),
      switchMap(() => [
        RequisitionsFlowsActions.fetchCollection(),
        RequisitionsFormActions.fetch(),
      ]),
    ),
  );
}
